import { render, staticRenderFns } from "./responses.vue?vue&type=template&id=1fc2f550&"
import script from "./responses.vue?vue&type=script&lang=js&"
export * from "./responses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports